<template>
    <costs @paginate="setPage" @sort="setSort" :loading="isFetching" :sort="sort" :records="paginatedRecords" :total="totalRecords" :display="display" :page="page" />
</template>
<script>
    import { mapActions, mapGetters, mapState } from 'vuex';
    import Costs from './Costs';

    export default {
        name: 'costs-container',
        components: {
            Costs,
        },
        data() {
            return {
                isFetching: true,
            }
        },
        methods: {
            ...mapActions('costs', [
                'fetchCosts',
                'setPage',
                'setSort',
                'resetState',
            ]),
        },
        computed: {
            ...mapState('costs', ['page', 'display', 'sort']),
            ...mapGetters('costs', ['paginatedRecords', 'totalRecords']),
        },
        created() {
            this.fetchCosts()
                .then((res) => {
                    this.isFetching = false;
                })
                .catch((res) => {
                    this.isFetching = false;
                });
        },
        destroyed() {
            this.resetState();
        },
    }
</script>



// WEBPACK FOOTER //
// CostsContainer.vue?5476006d